<template>
  <div class="my-2 mx-4">
    <el-dialog :visible.sync="showPopup" :title="'Phân quyền tài khoản - '+selectedEmployee.username" v-if="showPopup"
               width="1000px"
               destroy-on-close>
      <div>
        <div class="d-flex" style="height: 410px">
          <div class="flex-1 mx-2">
            <div class="font-size-16 fw-semibold">Danh sách tài khoản zalo</div>
            <div class="p-1" style="height: 360px;overflow-y: auto">
              <div v-if="accounts.length>0" class="d-flex mb-2">
                <el-checkbox :value="checkSelectedAccountAllTag()" @change="changeAllAccount()" />
                <div class="ms-2 fw-bolder">Chọn tất cả</div>
              </div>
              <el-input v-model="searchAccount" placeholder="Tìm tài khoản" clearable class="mb-2" />
              <div v-for="(account,index) in filterAccounts" :key="index">
                <div class="d-flex mt-1">
                  <el-checkbox :value="checkSelectedAccount(account.accountId)" @change="changeAccount(account)" />
                  <div class="px-2 fw-semibold">{{ getAccountName(account) }}</div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 360px;border-left:2px solid #DCDFE9"></div>
          <div class=" mx-2" style="width: 260px">
            <div class="font-size-16 fw-semibold">Danh sách tag chỉ định</div>
            <div class="p-1" style="height: 360px ;overflow-y: auto">
              <div v-if="tags.filter(p => p.assign === true && p.status === 'ACTIVE').length>0" class="d-flex mb-2">
                <el-checkbox :value="checkSelectedAllTagAssign()" @change="changeAllTagAssign()" />
                <div class="ms-2 fw-bolder">Chọn tất cả</div>
              </div>
              <div v-for="(tag,index) in tags" :key="index">
                <div class="d-flex mt-1" v-if="tag.status=='ACTIVE' && tag.assign">
                  <el-checkbox :value="checkSelectedTag(tag.id)" @change="changeTag(tag)" />
                  <div class="px-2">
                    <tag-custom :item="tag" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 390px;border-left:2px solid #DCDFE9"></div>
          <div class="flex-1 mx-2">
            <div class="font-size-16 fw-semibold">Danh sách tag hiển thị trên khung chat</div>
            <div style="border: 1px solid #DCDFE9; border-radius: 4px;padding: 8px 12px" class="mt-2">
              <el-radio v-model="radio" label="all" value="true">
                <span style="color: #000;">Tất cả tag</span>
              </el-radio>
            </div>
            <div style="border: 1px solid #DCDFE9; border-radius: 4px;padding: 8px 12px" class="mt-2">
              <el-radio v-model="radio" label="option" value="true">
                <span style="color: #000;">Tùy chọn</span>
              </el-radio>
              <div v-if="radio=='option'">
                <div style="border-top: 1px solid #DCDFE9" class="mt-2" />
                <div class="p-1" style="height: 230px ;overflow-y: auto">
                <el-input v-model="searchTag" placeholder="Tìm tên thẻ" clearable class="mb-2" />
                  <div v-for="(tag,index) in filterTags" :key="index">
                    <div class="d-flex mt-1" v-if="tag.status=='ACTIVE' && !tag.assign">
                      <el-checkbox :value="checkSelectedTagDisplay(tag.id)" @change="changeTagDisplay(tag)" />
                      <div class="px-2">
                        <tag-custom :item="tag" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="divider-custom" />
        <div class="d-flex justify-content-between">
          <div class="mt-2">
            <div class="d-flex">
              <el-checkbox v-model="selectedEmployee.option1">
                Cho phép hiển thị hội thoại chưa được gắn tag chỉ định
              </el-checkbox>
              <el-checkbox v-model="selectedEmployee.option2">
                Cho phép gắn tag chỉ định
              </el-checkbox>

            </div>
            <div class="d-flex">
              <el-checkbox style="width: 376px" v-model="selectedEmployee.showPhoneInContact">
                Cho phép hiển thị số điện thoại trong danh bạ
              </el-checkbox>
              <el-checkbox v-model="selectedEmployee.showListFriend">
                Cho phép hiển thị danh sách bạn bè
              </el-checkbox>
            </div>
            <div class="d-flex">
              <el-checkbox style="width: 376px" v-model="selectedEmployee.manageTags">
                Cho phép quản lý tag
              </el-checkbox>
              <el-checkbox v-model="selectedEmployee.manageAccounts">
                Cho phép quản lý danh sách tài khoản
              </el-checkbox>
            </div>
            <!-- <div class="d-flex">
              <el-checkbox style="width: 376px" v-model="selectedEmployee.showAIDashboard">
                Cho phép hiển thị AI tổng quát
              </el-checkbox>
            </div> -->
          </div>
          <div class="d-flex mt-2" style="height: 28px">
            <el-button size="mini" type="danger" plain @click="cancelBtnClick()">Hủy</el-button>
            <el-button size="mini" type="primary" @click="save()">Lưu</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="font-size-24 fw-bold d-flex justify-content-between align-items-center">
      <div>
        Quản lý nhân viên
      </div>
      <el-tooltip :content = "getHref()">
        <el-button @click="copyToClipboard(`https://salework.net/login/${app.user.companyAlias}`, 'Đã sao chép link đăng nhập')" type="primary"> Đăng nhập tài khoản nhân viên </el-button>
      </el-tooltip>
    </div>

    <div class="zalo-account-header d-flex mt-3">
      <i class="icon-user-fill font-size-32" />
      <div class="fw-bold font-size-16">Danh sách tài khoản nhân viên</div>
      <el-input placeholder="Tìm kiếm tên nhân viên" v-model="searchText" class="w-25" />

      <div class="flex-1" />
      <el-button v-if="employees.length!=0" type="primary" size="mini"
                 @click="newTab('https://salework.net/user/create')">+ Thêm nhân viên
      </el-button>
    </div>
    <div class="zalo-account-info p-2" v-loading="isLoading" element-loading-text="Đang tải dữ liệu..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="#f5f5f5">
      <div v-if="employees.length!=0 || isLoading">

        <div class="d-flex px-2 py-3 fw-bold  font-size-15">
          <div style="width: 80px" class=" text-center">STT</div>
          <div class="zalo-account-list-item-5">Tên đăng nhập</div>
          <div class="zalo-account-list-item-6">Tài khoản Zalo</div>
          <div class="zalo-account-list-item-1">Tag chỉ định</div>
          <div class="w-150px text-center">Phân quyền</div>
          <div class="w-150px text-center">Hành động</div>
        </div>
        <div class="zalo-account-list bg-white">
          <div v-for="(item, index) in viewEmployee" :key="index">
            <div class=" font-size-13">
              <div class="divider-custom mx-2" v-if="index == 0" />
              <div class="px-2 py-3 font-size-14">
                <div class="d-flex">
                  <div style="width: 80px" class=" text-center fw-semibold"> {{ index + 1 }}</div>
                  <div class="zalo-account-list-item-5 fw-semibold">{{ getUserName(item.username) }}</div>
                  <div class="zalo-account-list-item-6 ">
                    <div v-if="item.accounts.length>0">
                      <div v-for="(account,index) in item.accounts" :key="index">
                        <div v-if="showAccount(account)" class="fw-semibold">
                          {{ getAccountName(account) }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="zalo-account-list-item-1 flex-wrap">
                    <div v-if="item.tags.length>0" class="d-flex flex-wrap">
                      <div v-for="(tag,index) in item.tags" :key="index">
                        <div v-if="tag.status=='ACTIVE' && tag.assign">
                          <tag-custom :item="tag" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="w-150px text-center">
                    <el-button plain size="mini" @click="selectedEm(item)">Phân quyền</el-button>
                  </div>
                  <div class="w-150px d-flex justify-content-center">
                    <el-tooltip v-if="isEmployeeManageUser()" class="item pointer mx-1" effect="dark"
                                :content="contentActive(item.active)+' tài khoản'"
                                placement="top">
                      <el-switch v-model="item.active" @change="activeChange(item)" />
                    </el-tooltip>
                    <div class="mx-1" />


                  </div>
                </div>
                <div class="d-flex mt-2">

                </div>
              </div>

              <div class="divider-custom mx-2" v-if="index < employees.length - 1" />
            </div>
          </div>
        </div>
      </div>
      <div v-else class="flex-column my-3">
        <div class="d-flex justify-content-center">
          <el-image src="/assets/icon/icon_employee.svg" style="width: 140px;height: 140px" />
        </div>
        <div class="d-flex justify-content-center fw-semibold font-size-20">Doanh nghiệp của bạn chưa có nhân viên nào
          được
          tạo.
        </div>
        <div class="d-flex justify-content-center font-size-16">Bấm chọn Tạo mới để bắt đầu tạo nhân viên đầu tiên trong
          Salework Zalo.
        </div>
        <div class="d-flex justify-content-center mt-2">
          <el-button type="primary" size="mini" @click="newTab('https://salework.net/user/create')">+ Tạo mới
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>


import TagCustom from "./common/TagCustom";

export default {
  name: "UserEmployee",
  components: { TagCustom },
  data() {
    return {
      employees: [],
      selectedEmployee: { accounts: [] },
      showPopup: false,
      accounts: [],
      tags: [],
      isLoading: false,
      radio: "all",
      searchText: "",
      searchTag: "",
      searchAccount: "",
    };
  },
  computed: {
    viewEmployee() {
      return this.employees.filter(s => this.getUserName(s.username).toLowerCase().includes(this.searchText.toLowerCase()));
    },
    filterTags() {
      if (!this.searchTag) return this.tags;
      return this.tags.filter(tag =>
        tag.name.toLowerCase().includes(this.searchTag.toLowerCase())
      );
    },
    filterAccounts() {
      if (!this.searchAccount) return this.accounts;
      return this.accounts.filter(acc =>
        this.getAccountName(acc).toLowerCase().includes(this.searchAccount.toLowerCase())
      );
    }
  },
  methods: {
    showAccount(account) {
      if (account.status != "DELETED") {
        let filter = this.accounts.filter((a) => a.accountId == account.accountId);
        if (filter != null && filter.length > 0) {
          return true;
        }
      }
      return false;
    },
    getUserName(username) {
      return username.split("/")[1];
    },
    activeChange(item) {
      if (item.active) {
        let search = this.employees.filter(p => p.active);
        if (search != null && search.length > this.app.staffLimit) {
          this.alert("error", "Vui lòng mua thêm số lượng nhân viên.");
          item.active = false;
          return;
        }
      }
      this.$http.get("/api/employee/active", {
        params: { active: item.active, username: item.username }
      });
    },
    save() {
      let tagids = this.selectedEmployee.tags.map(p => {
        return p.id;
      });
      tagids.push(...this.selectedEmployee.tagDisplays.map(p => {
        return p.id;
      }));
      let request = {
        username: this.selectedEmployee.username,
        tagIds: tagids,
        accountIds: this.selectedEmployee.accounts.map(p => {
          return p.accountId;
        }),
        showAllTag: this.radio === "all",
        option1: this.selectedEmployee.option1,
        option2: this.selectedEmployee.option2,
        showPhoneInContact: this.selectedEmployee.showPhoneInContact,
        showListFriend: this.selectedEmployee.showListFriend,
        manageTags: this.selectedEmployee.manageTags,
        manageAccounts: this.selectedEmployee.manageAccounts,
        // showAIDashboard: this.selectedEmployee.showAIDashboard,
      };
      this.$http.post("/api/employee/save", request).then(() => {
        this.getAll();
      });
      this.showPopup = false;
    },
    cancelBtnClick() {
      this.showPopup = false;
    },
    checkSelectedAllTagAssign() {
      let arrTags = this.selectedEmployee.tags.filter(p => p.assign === true && p.status === "ACTIVE");
      let filter = this.tags.filter(p => p.assign === true && p.status === "ACTIVE");
      if (filter.length === 0) return false;
      return arrTags.length === filter.length;
    },

    changeAllTagAssign() {
      let arrTags = this.tags.filter(p => p.assign === true && p.status === "ACTIVE");
      let filter = this.selectedEmployee.tags.filter(p => p.assign === true && p.status === "ACTIVE");
      filter.forEach(x => {
        let index = this.selectedEmployee.tags.findIndex(s => s.id === x.id);
        if (index > -1) {
          this.selectedEmployee.tags.splice(index, 1);
        }
      });
      if (filter.length < arrTags.length) {
        arrTags.forEach(s => this.selectedEmployee.tags.push(s));
      }
    },
    changeAllAccount() {
      let arrAccs = this.filterAccounts;
      let filter = this.selectedEmployee.accounts;

      this.selectedEmployee.accounts = [];
      if (filter.length < arrAccs.length) {
        arrAccs.forEach(s => this.selectedEmployee.accounts.push(s));
      }
    },
    changeTag(tag) {
      let filter = this.selectedEmployee.tags.filter(p => p.id == tag.id);
      if (filter && filter.length > 0) {
        let index = this.selectedEmployee.tags.indexOf(filter[0]);
        this.selectedEmployee.tags.splice(index, 1);
      } else {
        this.selectedEmployee.tags.push(tag);
      }
    }, changeTagDisplay(tag) {
      let filter = this.selectedEmployee.tagDisplays.filter(p => p.id == tag.id);
      if (filter && filter.length > 0) {
        let index = this.selectedEmployee.tagDisplays.indexOf(filter[0]);
        this.selectedEmployee.tagDisplays.splice(index, 1);
      } else {
        this.selectedEmployee.tagDisplays.push(tag);
      }
    },
    checkSelectedAccountAllTag() {
      let filter = this.selectedEmployee.accounts;
      let listIdSelected = filter.map(s => s.accountId);
      if (this.filterAccounts.length === 0 || listIdSelected.length === 0) return false;
      for (let i = 0; i < this.filterAccounts.length; i++) {
        if (!listIdSelected.includes(this.filterAccounts[i].accountId)) return false;
      }
      return true;
    },

    changeAccount(account) {
      let filter = this.selectedEmployee.accounts.filter(p => p.accountId == account.accountId);
      if (filter && filter.length > 0) {
        let index = this.selectedEmployee.accounts.indexOf(filter[0]);
        this.selectedEmployee.accounts.splice(index, 1);
      } else {
        this.selectedEmployee.accounts.push(account);
      }
    },
    checkSelectedAccount(accountId) {
      let filter = this.selectedEmployee.accounts.filter(p => p.accountId == accountId);
      if (filter && filter.length > 0) return true;
      return false;
    },
    checkSelectedTag(id) {
      let filter = this.selectedEmployee.tags.filter(p => p.id == id);
      if (filter && filter.length > 0) return true;
      return false;
    },
    checkSelectedTagDisplay(id) {
      let filter = this.selectedEmployee.tagDisplays.filter(p => p.id == id);
      if (filter && filter.length > 0) return true;
      return false;
    },
    fetchAllTag() {
      this.$http.get("/api/tag/tagSetting").then(resp => {
        this.tags = resp.data;
      });

    },
    fetchAllAccount() {
      // this.$http.get("/api/account/getAll").then(resp => {
      //   this.accounts = resp.data;
      // });
      this.accounts = this.app.accounts;
    },
    optionChange(item) {
      item.option1 = !item.option1;
      this.$http.get("/api/employee/option1", {
        params: { option1: item.option1, username: item.username }
      });
    },
    contentActive(option) {
      if (option) return "Hủy kích hoạt";
      return "Kích hoạt";
    },
    contentOption(option) {
      if (option) return "Không cho phép";
      return "Cho phép";
    },
    selectedEm(item) {
      this.selectedEmployee = item;
      if (item.showAllTag) {
        this.radio = "all";
      } else {
        this.radio = "option";
      }
      this.showPopup = true;
    },
    getAll() {
      this.employees = [];
      this.isLoading = true;
      this.$http.get("/api/employee/all").then(val => {
        this.employees.push(...val.data);
      }).finally(() => this.isLoading = false);

    },
    getHref() {
      return `https://salework.net/login/${this.app.user.companyAlias}`;
    }
  },
  created() {
    this.getAll();
    this.fetchAllAccount();
    this.fetchAllTag();
  }
};
</script>

<style scoped>

</style>
